import { render, staticRenderFns } from "./antiBriberiyPredictiveRisk.vue?vue&type=template&id=a0ae6256"
import script from "./antiBriberiyPredictiveRisk.vue?vue&type=script&lang=js"
export * from "./antiBriberiyPredictiveRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports